import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!window.gsap || !window.ScrollTrigger) return

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    this.tweens = []

    if (this.reducedMotion) return

    const layers = this.element.querySelectorAll("[data-parallax]")
    layers.forEach((layer) => {
      const speed = parseFloat(layer.dataset.parallax) || 0.3
      const direction = layer.dataset.parallaxDirection || "y"
      const movement = (1 - speed) * -50

      const props = {
        scrollTrigger: {
          trigger: this.element,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      }
      props[direction === "x" ? "xPercent" : "yPercent"] = movement

      this.tweens.push(window.gsap.to(layer, props))
    })
  }

  disconnect() {
    this.tweens.forEach((tween) => {
      if (tween.scrollTrigger) tween.scrollTrigger.kill()
      tween.kill()
    })
    this.tweens = []
  }
}
